export const asyncWait = <T>(ms: number, data?: T) => new Promise<T>(resolve => {
  setTimeout(() => resolve(data), ms);
});
